<template>
  <section class="identity" aria-labelledby="person-name">
    <div class="avatar" aria-hidden="true">
      <img v-if="person.urlFoto" :src="person.urlFoto" alt="">
      <span v-else>{{ initials }}</span>
    </div>
    <div class="identity-content">
      <div>
        <h1 id="person-name">{{ person.nome }}</h1>
        <p>{{ person.email || 'E-mail não informado' }}</p>
        <small>ID {{ person.idPessoa }}</small>
      </div>
      <div class="chips" aria-label="Perfis da pessoa">
        <span v-for="profile in profiles" :key="profile" class="profile-chip">
          {{ profileLabel(profile) }}
        </span>
        <span v-if="hasAnomalies" class="profile-chip warning">Revisão necessária</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PessoaIdentityHeader',
  props: {
    person: { type: Object, required: true },
    profiles: { type: Array, default: () => [] },
    hasAnomalies: { type: Boolean, default: false }
  },
  computed: {
    initials () {
      return String(this.person.nome || '?')
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()
    }
  },
  methods: {
    profileLabel (profile) {
      return {
        person: 'Pessoa',
        student: 'Aluno',
        collaborator: 'Colaborador',
        user: 'Usuário'
      }[profile] || profile
    }
  }
}
</script>

<style lang="scss" scoped>
.identity { display: flex; align-items: center; gap: $mg_small; padding: $hmg_mid; background: $color-secondary; border: $border-component; border-radius: $border-radius; }
.avatar { width: 88px; height: 88px; flex: 0 0 88px; display: grid; place-items: center; overflow: hidden; border-radius: 50%; border: 3px solid $color-primary; background: $color-bg; color: $color-primary; font-size: 24px; font-weight: 700; }
.avatar img { width: 100%; height: 100%; object-fit: cover; }
.identity-content { flex: 1; display: flex; align-items: center; justify-content: space-between; gap: $mg_small; min-width: 0; }
h1 { margin: 0; font-size: 24px; overflow-wrap: anywhere; }
p { margin: $hmg_mini 0 0; color: $color-text; overflow-wrap: anywhere; }
small { display: block; margin-top: $hmg_mini; color: $color-text; }
.chips { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: $hmg_mini; }
.profile-chip { display: inline-flex; align-items: center; min-height: 30px; padding: 0 $mg_mini; border-radius: $border-radius-xlarge; background: $color-bg; border: $border-component; font-size: $font-size-small; font-weight: 700; }
.profile-chip.warning { border-color: $color-warning !important; }
@media (max-width: 720px) {
  .identity { align-items: flex-start; }
  .avatar { width: 64px; height: 64px; flex-basis: 64px; }
  .identity-content { align-items: flex-start; flex-direction: column; }
  .chips { justify-content: flex-start; }
  h1 { font-size: 20px; }
}
</style>
